// extracted by mini-css-extract-plugin
module.exports = {"desktopFx":"styles_desktopFx__x8Ujy","historyFiltersFx":"styles_historyFiltersFx__3TIyf","profileInformationToggleContent":"styles_profileInformationToggleContent__2Sv93"};